import type { MediaVideoDataFragment } from "../graphql/types";

export interface VideoProps {
  className?: string;
  visible: boolean;
  video: MediaVideoDataFragment;
}

export function Video(props: VideoProps) {
  const { className, video } = props;

  return (
    <video
      autoPlay
      loop
      muted
      webkit-playsinline="true"
      playsInline
      className={className}>
      {video.sources.map(({ src, type }) => (
        <source key={type} src={src} type={type} />
      ))}
    </video>
  );
}
